var _a;
export var ServerErrorCode;
(function (ServerErrorCode) {
    ServerErrorCode[ServerErrorCode["NOT_FOUND"] = 404] = "NOT_FOUND";
    ServerErrorCode[ServerErrorCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    ServerErrorCode[ServerErrorCode["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    ServerErrorCode[ServerErrorCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    ServerErrorCode[ServerErrorCode["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    ServerErrorCode[ServerErrorCode["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    ServerErrorCode[ServerErrorCode["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    ServerErrorCode[ServerErrorCode["CONFLICT"] = 409] = "CONFLICT";
    ServerErrorCode[ServerErrorCode["GONE"] = 410] = "GONE";
    ServerErrorCode[ServerErrorCode["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    ServerErrorCode[ServerErrorCode["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    ServerErrorCode[ServerErrorCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    ServerErrorCode[ServerErrorCode["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
    ServerErrorCode[ServerErrorCode["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    ServerErrorCode[ServerErrorCode["RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
    ServerErrorCode[ServerErrorCode["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    ServerErrorCode[ServerErrorCode["I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
    ServerErrorCode[ServerErrorCode["AUTHENTICATION_TIMEOUT"] = 419] = "AUTHENTICATION_TIMEOUT";
    ServerErrorCode[ServerErrorCode["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
    ServerErrorCode[ServerErrorCode["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    ServerErrorCode[ServerErrorCode["LOCKED"] = 423] = "LOCKED";
    ServerErrorCode[ServerErrorCode["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
    ServerErrorCode[ServerErrorCode["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    ServerErrorCode[ServerErrorCode["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    ServerErrorCode[ServerErrorCode["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    ServerErrorCode[ServerErrorCode["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    ServerErrorCode[ServerErrorCode["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    ServerErrorCode[ServerErrorCode["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
    ServerErrorCode[ServerErrorCode["VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
    ServerErrorCode[ServerErrorCode["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
    ServerErrorCode[ServerErrorCode["BANDWIDTH_LIMIT_EXCEEDED"] = 509] = "BANDWIDTH_LIMIT_EXCEEDED";
    ServerErrorCode[ServerErrorCode["NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
})(ServerErrorCode || (ServerErrorCode = {}));
export var SERVER_ERRORS = (_a = {},
    _a[ServerErrorCode.NOT_FOUND] = { description: 'Not Found' },
    _a[ServerErrorCode.FORBIDDEN] = { description: 'Forbidden' },
    _a[ServerErrorCode.BAD_REQUEST] = { description: 'Bad Request' },
    _a[ServerErrorCode.UNAUTHORIZED] = { description: 'Unauthorized' },
    _a[ServerErrorCode.METHOD_NOT_ALLOWED] = { description: 'Method Not Allowed' },
    _a[ServerErrorCode.REQUEST_TIMEOUT] = { description: 'Request Timeout' },
    _a[ServerErrorCode.NOT_ACCEPTABLE] = { description: 'Not Acceptable' },
    _a[ServerErrorCode.CONFLICT] = { description: 'Conflict' },
    _a[ServerErrorCode.GONE] = { description: 'Gone' },
    _a[ServerErrorCode.LENGTH_REQUIRED] = { description: 'Length Required' },
    _a[ServerErrorCode.PRECONDITION_FAILED] = { description: 'Precondition Failed' },
    _a[ServerErrorCode.PAYLOAD_TOO_LARGE] = { description: 'Payload Too Large' },
    _a[ServerErrorCode.URI_TOO_LONG] = { description: 'URI Too Long' },
    _a[ServerErrorCode.UNSUPPORTED_MEDIA_TYPE] = {
        description: 'Unsupported Media Type',
    },
    _a[ServerErrorCode.RANGE_NOT_SATISFIABLE] = {
        description: 'Range Not Satisfiable',
    },
    _a[ServerErrorCode.EXPECTATION_FAILED] = { description: 'Expectation Failed' },
    _a[ServerErrorCode.I_AM_A_TEAPOT] = { description: 'I’m a teapot' },
    _a[ServerErrorCode.AUTHENTICATION_TIMEOUT] = {
        description: 'Authentication Timeout',
    },
    _a[ServerErrorCode.MISDIRECTED_REQUEST] = { description: 'Misdirected Request' },
    _a[ServerErrorCode.UNPROCESSABLE_ENTITY] = {
        description: 'Unprocessable Entity',
    },
    _a[ServerErrorCode.LOCKED] = { description: 'Locked' },
    _a[ServerErrorCode.FAILED_DEPENDENCY] = { description: 'Failed Dependency' },
    _a[ServerErrorCode.INTERNAL_SERVER_ERROR] = {
        description: 'Internal Server Error',
    },
    _a[ServerErrorCode.NOT_IMPLEMENTED] = { description: 'Not Implemented' },
    _a[ServerErrorCode.BAD_GATEWAY] = { description: 'Bad Gateway' },
    _a[ServerErrorCode.SERVICE_UNAVAILABLE] = { description: 'Service Unavailable' },
    _a[ServerErrorCode.GATEWAY_TIMEOUT] = { description: 'Gateway Timeout' },
    _a[ServerErrorCode.HTTP_VERSION_NOT_SUPPORTED] = {
        description: 'HTTP Version Not Supported',
    },
    _a[ServerErrorCode.VARIANT_ALSO_NEGOTIATES] = {
        description: 'Variant Also Negotiates',
    },
    _a[ServerErrorCode.INSUFFICIENT_STORAGE] = {
        description: 'Insufficient Storage',
    },
    _a[ServerErrorCode.BANDWIDTH_LIMIT_EXCEEDED] = {
        description: 'Bandwidth Limit Exceeded',
    },
    _a[ServerErrorCode.NOT_EXTENDED] = { description: 'Not Extended' },
    _a);
//# sourceMappingURL=serverError.js.map